// Bas de la barre latérale : numéro de version et journal des mises à jour (CHANGELOG.md à la
// racine, mis à jour avec chaque envoi — Jim, 02/11/2026). Un clic ouvre le journal.

import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { version } from '../../../package.json';
import JOURNAL from '../../../CHANGELOG.md?raw';
import { lisJournal } from '@/lib/journal';

// **gras** seulement : le journal est écrit à la main, sans autre mise en forme.
const enGras = (t) => t.split(/\*\*(.+?)\*\*/g).map((m, i) => (i % 2 ? <b key={i}>{m}</b> : m));

export default function Nouveautes() {
  const [ouvert, setOuvert] = useState(false);
  const blocs = ouvert ? lisJournal(JOURNAL) : [];
  return (
    <>
      <button type="button" onClick={() => setOuvert(true)}
        className="mx-3 mb-3 flex items-center gap-2 min-h-[40px] px-3 rounded-[10px] text-xs font-semibold text-foreground-secondary hover:bg-muted">
        <Sparkles className="w-4 h-4" aria-hidden="true" />
        <span>v{version} · Nouveautés</span>
      </button>
      <Dialog open={ouvert} onOpenChange={setOuvert}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Nouveautés — version {version}</DialogTitle>
            <DialogDescription>Les mises à jour de la plateforme, de la plus récente à la plus ancienne.</DialogDescription>
          </DialogHeader>
          <div className="text-[13px] space-y-1.5">
            {blocs.map((b, i) => {
              if (b.type === 'version') return <h3 key={i} className="text-[15px] font-extrabold pt-3 first:pt-0">{b.texte}</h3>;
              if (b.type === 'rubrique') return <h4 key={i} className="text-[13px] font-bold text-primary pt-2">{b.texte}</h4>;
              if (b.type === 'puce') return <p key={i} className="pl-3 relative before:content-['•'] before:absolute before:left-0">{enGras(b.texte)}</p>;
              if (b.type === 'sous') return <p key={i} className="pl-7 relative text-foreground-secondary before:content-['–'] before:absolute before:left-4">{enGras(b.texte)}</p>;
              return <p key={i} className="text-foreground-secondary">{enGras(b.texte)}</p>;
            })}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
